import React from "react";
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from 'react-router-dom';
import './App.css';
import Home from "./components/pages/Home";
import About from './components/pages/About/About';
import Projects from './components/pages/Projects/Projects';
import Resume from './components/pages/Resume/Resume';
import RootLayout from "./layouts/RootLayout";
import Achievements from "./components/pages/Achievements/Achievements";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<RootLayout />}>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/projects" element={<Projects />} />
      <Route path="/achievements" element={<Achievements/>}/>
      <Route path="/resume" element={<Resume />} /> 
    </Route>
  )
)

const App = () => {
  return (
    <div className="App">
      <div className="gradientBG">
        <RouterProvider router={router} />
      </div>
    </div>
  )
}

export default App;